// utils
import get from "../../../utils/GetNested";
import getPrettyIntegrationName from "../../../utils/getPrettyIntegrationName";

const selectSyncType = (log) => {
	if (log?.integration_type === "integration-sync") {
		return "integration";
	} else if (log?.integration_type === "csv" || log?.integration_type === "sftp-upload") {
		return "sftp";
	} else if (log?.integration_type === "csv-upload") {
		return "csv";
	} else if (log?.integration_type === "connect-workers") {
		return "connect-workers";
	} else if (log?.integration_type === "public-api") {
		return "public-api";
	}

	return null;
};

export const selectSyncInformation = (log) => {
	const type = selectSyncType(log);

	if (type === "integration") {
		const integrationName = get(log, ["integrationProperties", "integrationName"], "");
		return `${getPrettyIntegrationName(integrationName)} Integration`;
	} else if (type === "sftp") {
		const sftpName = get(log, ["sftp_properties", "sftp_integration_name", "name"], "");
		return `${sftpName} SFTP Sync`;
	} else if (type === "csv") {
		return "CSV Upload";
	} else if (type === "connect-workers") {
		let integrationName = get(log, ["integrationProperties", "integrationName"], "");
		if (integrationName.length > 0) {
			integrationName = integrationName[0].toUpperCase() + integrationName.slice(1);
		}

		return `${integrationName} Integration Settings Update`;
	} else if (type === "public-api") {
		return "Public API";
	}

	return "";
};

export const selectTotalEmployees = (log) => {
	const type = selectSyncType(log);

	if (type === "integration") {
		return get(log, ["integrationProperties", "connectedEmployeesCount"], "");
	} else if (type === "connect-workers") {
		return get(log, ["connect_worker_properties", "numUsersAttemptedToSync"], "");
	} else if (type === "public-api") {
		return (
			get(log, ["users_successfully_synced"], 0) +
			get(log, ["users_failed_sync"], 0) +
			get(log, ["users_with_no_changes"], 0)
		);
	}

	return get(log, ["csv_properties", "num_users_in_csv"], "");
};
